var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Goal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.61 37.51L55.18 17v-5.77L62 4.53v8.7h7.55L63.18 20h-5.32L37.58 40.29a2.044 2.044 0 11-3-2.78h.03zM57.36 26A25 25 0 1149 17.64l2.85-2.92A29 29 0 1060.2 23l-2.84 3zm-11.7-5A20.45 20.45 0 1054 29.5l-2.8 2.94a16.61 16.61 0 11-8.34-8.5l2.8-2.94zm-9.89 10.24l3-3a10.779 10.779 0 00-2.77-.41A11.17 11.17 0 1047.17 39c.01-.714-.047-1.427-.17-2.13l-3.31 3.45a7.77 7.77 0 11-7.88-9.08h-.04z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Goal.db9bf6df.svg";
export { SvgK1Goal as ReactComponent };